import AddToCalendar from '@culturehq/add-to-calendar';
import '@culturehq/add-to-calendar/dist/styles.css';
import './styles.css';

export default AddToCalendar;
